import { checkNullId } from '@/shared/lib';
import _ from 'lodash';
import type { KeyboardEvent } from 'react';

/**
 * Moves focus to the next field of the new study step 2 form when Enter is pressed. Locates the event target's id within the id list and focuses the following element when both ids resolve in the DOM, deliberately skipping preventDefault so react-select can still pick an option on Enter.
 *
 * @param e - Keyboard event from the focused input.
 * @param idArr - Ordered element ids describing the tab sequence.
 * @returns Nothing.
 */
const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>, idArr: string[]) => {
  const idIndex =
    _.indexOf(idArr, (e.target as HTMLInputElement).id) !== -1
      ? _.indexOf(idArr, (e.target as HTMLInputElement).id)
      : null;
  if (idIndex === null) return;
  if (e.key === 'Enter' && checkNullId(idArr[idIndex]) && checkNullId(idArr[idIndex + 1])) {
    // *: Do not use preventDefault to allow react select input select option when pressing Enter
    document.getElementById(idArr[idIndex + 1])?.focus();
  }
};

export { handleKeyDown };
